import Splide from "@splidejs/splide";
import { Grid } from "@splidejs/splide-extension-grid";
import { Intersection } from "@splidejs/splide-extension-intersection";

function initSplideLogos(context) {
	const root = context && typeof context.querySelectorAll === "function" ? context : document;
	// .editor-styles-wrapper doit être cherché dans le document réel du bloc (iframe admin ou document front)
	const ownerDoc = root.nodeType === 9 ? root : root.ownerDocument || document;
	const isEditor = !!ownerDoc.querySelector(".editor-styles-wrapper");
	const sliderLogos = root.querySelectorAll(".grid-logos");

	if (!isEditor) {
		sliderLogos.forEach((el) => {
			const slider = el.querySelector(".splide-logos");
			const rows = parseInt(el.dataset.rows) || 3;

			const sliderGridLogo = new Splide(slider, {
				type: "slide",
				pagination: true,
				arrows: true,
				drag: true,
				interval: 6000,
				speed: 700,
				focus: 0,
				omitEnd: true,
				autoplay: "pause",
				pauseOnHover: true,
				intersection: {
					inView: {
						autoplay: true,
					},
					outView: {
						autoplay: false,
					},
				},
				gap: "60px",
				grid: {
					rows: rows,
					cols: 7,
					gap: { row: "30px", col: "60px" },
				},
				breakpoints: {
					1200: {
						gap: "50px",
						grid: {
							cols: 6,
							gap: { row: "30px", col: "50px" },
						},
					},
					1024: {
						gap: "40px",
						grid: {
							cols: 5,
							gap: { row: "30px", col: "40px" },
						},
					},
					500: {
						gap: "20px",
						grid: {
							cols: 4,
							gap: { row: "30px", col: "20px" },
						},
					},
				},
			});

			sliderGridLogo.on("overflow", function (isOverflow) {
				sliderGridLogo.options = {
					arrows: isOverflow,
					pagination: isOverflow,
					drag: isOverflow,
				};
			});

			sliderGridLogo.mount({ Grid, Intersection });

	
		});
	}
}

// Front-end
document.addEventListener("DOMContentLoaded", () => initSplideLogos());

// Gutenberg / ACF editor
if (window.acf) {
	window.acf.addAction("render_block_preview/type=bloc-grid-logo", ($block) => {
		initSplideLogos($block && $block.jquery ? $block.get(0) : $block);
	});
}
